import { render, staticRenderFns } from "./MultiChatViewer.vue?vue&type=template&id=7c21f3c9"
import script from "./MultiChatViewer.vue?vue&type=script&lang=js"
export * from "./MultiChatViewer.vue?vue&type=script&lang=js"
import style0 from "./MultiChatViewer.vue?vue&type=style&index=0&id=7c21f3c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports